import React, { useEffect, useState, } from 'react'
import { Link, } from 'react-router-dom'

import $ from 'jquery';
import Swal from 'sweetalert2';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, setBadgeStatusGeneric, numberSet, separatorsNumbersSet, styles,
    sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection, lodash, awaitDelay,
} from '../../helpers/settings'

import Menu from '../main/Menu'
import CollectionCashAddEditDetails from './CollectionCashAddEditDetails';
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationCoinGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { coinModelGet } from '../../models/coins/coin';

const currentMethod = 'CollectionCashes';
const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

const { colors, labels, messages, icons, react, } = globalSettings;
const { backend, } = globalSettings?.app;
const { properties: dbProps, } = globalSettings?.collections;
const { operators: dbOpera, } = globalSettings?.react?.firebase;
const {sweetAlert2, } = react;

export default function CollectionCashes({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    //const history = useHistory();
    //const [showData, setShowData] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, collectionCashes: true, });
    const [isEditDelete, setIsEditDelete] = useState(false);
    const [headerSectionValues, setHeaderSectionValues] = useState(
        {
            levelOne: {
                colOne: {},
                colTwo: {},
                colThree: {
                    label: labels?.balance?.[languageObj?.id],
                    value: neutralValueStr,
                    icon: icons?.moneyBillWave,
                    className: 'form-control bg-transparent text-black text-right',
                },
            },
        }
    );
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    let process = {
        edit: false,
        details: false,
        delete: false,
    };
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region buildings
    const buildingsId = 'buildingsId';
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //const [buildingBalance, setBuildingBalance] = useState(0.00);
    //#endregion buildings

    //#region collectionCaches
    const dtCollectionCashesId = 'dtCollectionCashes';
    const [collectionCash, setCollectionCash] = useState({
        ...collectionCashModelGet({}),
        process: process,
    });
    const [collectionCashShowModal, setCollectionCashShowModal] = useState(false);
    const [dtCollectionCashesRowIndex, setDtCollectionCashesRowIndex] = useState(0);
    const [btnCollectionCashesSyncDisabled, setBtnCollectionCashesSyncDisabled] = useState(true);
    //#endregion collectionCaches

    //#region coins
    const [coins, setCoins] = useState([coinModelGet({})]);
    //#endregion coins

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            collectionCashes: {
                buttons: {
                    add: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btndtCollectionCashesIdAdd',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btndtCollectionCashesIdDelete',
                    },
                },
                icons: {
                    add: {
                        id: 'icondtCollectionCashesIdAdd',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icondtCollectionCashesIdDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCollectionCashesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCollectionCashesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spdtCollectionCashesIdAdd',
                        className: '',
                    },
                    delete: {
                        id: 'spdtCollectionCashesIdDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region collectionCaches (methods)
    const dataTableCollectionCashesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableCollectionCashesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtCollectionCashesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '25%', },
                    { title: labels?.date?.[languageObj?.id], width: '15%', },
                    { title: labels?.condition?.[languageObj?.id], className: 'text-center', width: '15%', },
                    { title: labels?.initialBalance?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.currentBalance?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtCollectionCashesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const collectionCashesGetAsync = async ({
        e = {},
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashesGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let collectionCashesLocal = [];
            let buildingLocal = buildingModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            processType_ = processType_ === 's' || processType_ === 'b' ? 0 : processType_;
            //#endregion variables

            setShowLoading({ building: false, collectionCashes: true, });

            //#region variables initialize
            setBuilding({});
            setIsEditDelete(false);
            setProcessType(processType_);
            setBtnCollectionCashesSyncDisabled(true);
            headerSectionValues.levelOne.colThree.value = neutralValueStr;
            setHeaderSectionValues(headerSectionValues);
            //#endregion variables initialize

            //#region dataTablesClear
            response = await dataTablesClearSetAsync({
                collectionCashes: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, collectionCashes: false, });
                return;
            }
            //#endregion dataTablesClear

            //#region data get (collection cashes)
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                setBuilding(buildingLocal);
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        limit: 0,
                        ordersBy: [
                            { field: dbProps?.description, value: 'asc' },
                        ],
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                        ],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, collectionCashes: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    collectionCashesLocal = response?.result || [];
                    if (!isUndNullEmp({ data: collectionCashesLocal, subMethod: currentMethod, })?.result && collectionCashesLocal?.length > 0) {
                        collectionCashesLocal?.forEach((detail) => {
                            //#region old code
                            // processButtonsLocal = [
                            //     { isVisible: true, showDivider: false, label: labels?.movements?.[languageObj?.id], isEnabled: true, methodName: 'movements', icon: icons?.chartLine, },
                            //     {
                            //         isVisible: true,
                            //         showDivider: true,
                            //         label: labels?.delete?.[languageObj?.id],
                            //         //isEnabled: true, 
                            //         isEnabled: processEvaluateGet(
                            //             detail,
                            //             labels?.process?.en?.toLowerCase(),
                            //             labels?.delete?.en?.toLowerCase(),
                            //             currentMethod
                            //         ).result,
                            //         methodName: 'delete',
                            //         icon: icons?.trash,
                            //     },
                            // ];
                            //#endregion old code
                            //#region variables
                            dataObj = {
                                description: detail?.description,
                                date: dateTimeFormatGlobalSet({
                                    date: detail?.date,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                condition: setBadgeStatusGeneric({
                                    type: detail?.inactive ? 1 : 0,
                                    value: detail?.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id],
                                    subMethod: currentMethod,
                                }),
                                initialBalance: separatorsNumbersSet({
                                    number: numberSet({
                                        number: detail?.initialBalance,
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result,
                                currentBalance: separatorsNumbersSet({
                                    number: numberSet({
                                        number: detail?.currentBalance,
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result,
                                processButtons: [
                                    {
                                        isVisible: true,
                                        showDivider: false,
                                        label: labels?.movements?.[languageObj?.id],
                                        isEnabled: true,
                                        methodName: backend?.methods?.movements,
                                        icon: icons?.chartLine,
                                    },
                                    {
                                        isVisible: true,
                                        showDivider: true,
                                        label: labels?.delete?.[languageObj?.id],
                                        isEnabled: processEvaluateGet({
                                            object: detail,
                                            property: labels?.process?.en?.toLowerCase(),
                                            process: labels?.delete?.en?.toLowerCase(),
                                            subMethod: currentMethod,
                                        })?.result,
                                        methodName: backend?.methods?.delete,
                                        icon: icons?.trash,
                                    },
                                ],
                            };
                            //#endregion variables

                            //#region methods
                            dtRows.push([
                                //#region old code
                                // detail.description,
                                // dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                                // setBadgeStatusGeneric((detail.inactive ? 1 : 0), (detail.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id])),
                                // //separatorsNumbersSet(numberSet((detail.initialBalance + detail.initialBalanceCash), 'd').result, true).result,
                                // separatorsNumbersSet(numberSet((detail.initialBalance), 'd').result, true).result,
                                // separatorsNumbersSet(detail.currentBalance, true).result,
                                //#endregion old code
                                dataObj?.description,
                                dataObj?.date,
                                dataObj?.condition,
                                dataObj?.initialBalance,
                                dataObj?.currentBalance,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.description,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: false,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: false,
                                    processButtons: dataObj?.processButtons,
                                    subMethod: currentMethod,
                                })?.result,
                            ]);
                            //#endregion methods
                        });

                        //#region calulcate building balance
                        response = await buildingBalanceCalculateSetAsync({
                            collectionCash: collectionCashesLocal?.[0],
                            subMethod: currentMethod,
                        })

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ building: false, collectionCashes: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion calulcate building balance
                    }

                    //#region set id edit / delete
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result;
                    isDeleteLocal = isEditLocal;

                    setIsEditDelete(isEditLocal && isDeleteLocal);
                    //#endregion set if edit delete

                    setBtnCollectionCashesSyncDisabled(false);
                }
            }
            //#endregion data get (collection cashes)

            //#region dataTable data set
            $(`#${dtCollectionCashesId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
            //#endregion dataTable data set

            setShowLoading({ building: false, collectionCashes: false, });
        } catch (ex) {
            setShowLoading({ building: false, collectionCashes: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const collectionCashAddEditGetAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashAddEditGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let collectionCashLocal = collectionCashModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            if (processType_ === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCashes: true, });
            }

            //#region variables initialize
            setCollectionCash({});
            setProcessType(processType_);
            //#endregion variables initialize

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //#region get coins
                response = await coinsGetAsync({
                    buildingId: buildingIdLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType_ === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else {
                        setShowLoading({ building: false, collectionCashes: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion get coins

                //#region get / set collection cash
                if (processType_ === 0) {
                    setCollectionCash(
                        collectionCashModelGet({
                            buildingId: buildingIdLocal,
                            coinId: '',
                            userId: auth?.user?.uid
                        })
                    );
                } else {
                    //#region get collection cashes
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            languageId: languageObj?.id,
                        },
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/${id}`
                    };

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType_ === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else {
                            setShowLoading({ building: false, collectionCashes: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    collectionCashLocal = response?.result || {};
                    setCollectionCash(collectionCashLocal);
                    //#endregion get collection cashes
                }
                //#endregion get / set collection cash
            } else {
                if (processType_ === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else {
                    setShowLoading({ building: false, collectionCashes: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region data set
            setProcessType(processType_);
            setDtCollectionCashesRowIndex(rowIndex);
            //#endregion data set

            setCollectionCashShowModal(true);

            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCashes: false, });
            }
        } catch (ex) {
            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCashes: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localCollectionCashDeleteGet = (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         setDtCollectionCashesRowIndex(rowIndex);
    //         setCollectionCash({});
    //         setCollectionCash({ ...collectionCash, id, description, });
    //         $(`#${controls?.dataTables?.collectionCashes?.buttons?.delete?.id}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCollectionCashDeleteGet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localCollectionCashDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region show alert to delete

    //         let msgText = `${labels?.cashRegister?.[languageObj?.id]}: <b>${collectionCash.description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         const swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         //#region old code

    //         // Swal.fire(swalProperties).then((result) => {
    //         //     if (result.isConfirmed) {
    //         //         collectionCashDeleteAsync();
    //         //     }
    //         // });

    //         //#endregion old code

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show alert to delete

    //         //#region delete data
    //         if (isConfirmed) {
    //             collectionCashDeleteAsync();
    //         }
    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCollectionCashDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    const collectionCashDeleteAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            let collectionCashLocal = collectionCashModelGet({});
            //#endregion variables

            //#region show message
            let msgTextObj = {
                one: `${labels?.collectionCash?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region delete collection cash
                        headerObj = {
                            headers: {
                                languageId: languageObj?.id,
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/${id}`
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        collectionCashLocal = response?.result || {};
                        //#endregion delete collection cash

                        //#region calculate (building balance)
                        response = await buildingBalanceCalculateSetAsync({
                            collectionCash: collectionCashLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion calculate (building balance)

                        //#region delete collection cash (dataTable)
                        $(`#${dtCollectionCashesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete collection cash (dataTable)

                        //#region data set
                        setCollectionCash({});
                        setDtCollectionCashesRowIndex(0);
                        //#endregion data set

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const collectionCashMovements = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashMovements';
        let response = responseGet();
        try {
            setShowLoading({ building: false, collectionCashes: true, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, })

            window.location.href = `${backend?.urlCollectionCashMovements}/${id}`;
            setShowLoading({ building: false, collectionCashes: false, });
        } catch (ex) {
            setShowLoading({ building: false, collectionCashes: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion collectionCaches (methods)

    //#region coins (methods)
    const coinsGetAsync = async ({
        buildingId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'coinsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let coinsLocal = [];
            //#endregion variables

            //#region variables initialize
            setCoins(coinsLocal);
            //#endregion variables initialize

            //#region coins get
            response = await validationCoinGetAsync({
                buildingId: buildingId,
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            coinsLocal = response?.result || [];
            setCoins(coinsLocal);
            //#endregion coins get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion coins (methods)

    //#region buildings (methods)
    const buildingBalanceCalculateSetAsync = async ({
        collectionCash = collectionCashModelGet({}),
        subMethod = '',
    }) => {
        const currentMethod = 'buildingBalanceCalculateSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let buildingBalanceLocal = neutralValue;
            let collectionCashesLocal = [collectionCashModelGet({})];
            //#endregion variables

            //#region data get (collection cashes)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: collectionCash?.buildingId, },
                ],
                ordersBy: [
                    { field: dbProps?.description, value: 'asc' },
                ],
                buildingId: collectionCash?.buildingId,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            collectionCashesLocal = response?.result || [];
            if (!isUndNullEmp({ data: collectionCashesLocal, subMethod: currentMethod, })?.result && collectionCashesLocal?.length > 0) {
                buildingBalanceLocal = numberSet({
                    //number: sumBy(collectionCashesLocal, 'currentBalance'),
                    number: lodash?.sum({
                        data: collectionCashesLocal,
                        key: dbProps?.currentBalance,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                buildingBalanceLocal = neutralValue;
            }
            //#endregion data get (collection cashes)

            //#region set heder data
            headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                number: buildingBalanceLocal,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            setHeaderSectionValues(headerSectionValues);
            //#endregion set heder data
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion buildings (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, collectionCashes: true, });

            //#region variables initialize
            setBuilding({});
            setBuildings([]);
            setIsEditDelete(false);
            //#endregion variables initialize

            //#region dataTables set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, collectionCashes: false, });
                return;
            }
            //#endregion dataTables set

            //#region buildings get
            if (!isUndNullEmp({ data: auth?.user?.uid, subMethod: currentMethod, })?.result ||
                !isUndNullEmp({ data: auth?.user?.id, subMethod: currentMethod, })?.result) {
                response = await buildingsByUserGetAsync({
                    userRole: userRole,
                    auth: auth,
                    urlGoTo: backend?.urlCollectionCashes,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, collectionCashes: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                    setBuildings(response?.result?.buildings);
                }
            }
            //#endregion buildings get

            setShowLoading({ building: false, collectionCashes: false, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTableCollectionCashesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region collection cashes
            $(`#${dtCollectionCashesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCollectionCashesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            collectionCashAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            collectionCashAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'movements':
                            collectionCashMovements({ id: id, description: description, rowIndex: dtRowIndex, processType: 3, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            collectionCashDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion collection cashes
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearSetAsync = async ({
        collectionCashes = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClearSetAsync';
        let response = responseGet();
        try {
            if (collectionCashes) {
                $(`#${dtCollectionCashesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.collectionCashes?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.collectionCashes?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.collectionCashes?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.collectionCashes?.icons?.add?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.icons?.add?.className);
                    $(`#${controls?.dataTables?.collectionCashes?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.collectionCashes?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.spinners?.add?.className);


                    $(`#${controls?.dataTables?.collectionCashes?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.collectionCashes?.buttons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.collectionCashes?.spinners?.delete?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.collectionCashes?.icons?.delete?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.icons?.delete?.className);
                    $(`#${controls?.dataTables?.collectionCashes?.buttons?.delete?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.buttons?.delete?.className);
                    $(`#${controls?.dataTables?.collectionCashes?.spinners?.delete?.id}`)?.addClass(controls?.dataTables?.collectionCashes?.spinners?.delete?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.collectionCashes?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.collectionCashes?.spinners?.add?.id}`)?.addClass(`${react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.collectionCashes?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.collectionCashes?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.collectionCashes?.buttons?.add?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.collectionCashes?.buttons?.delete?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
        //console?.log(0);
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='collection' process='collectionCashes' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.cashRegisters?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.cashRegisters?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/*buildings*/}
                                <BuildingHeader buildingsId={buildingsId}
                                    building={building}
                                    buildings={buildings}
                                    btnSyncDisabled={btnCollectionCashesSyncDisabled}
                                    methodGetAsync={collectionCashesGetAsync}
                                    processType={0}
                                    headerSectionValues={headerSectionValues}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*collectionCahes*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.collectionCashes}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.cashRegisters?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.collectionCashLogo}></img> - {labels?.cashRegisters?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <button id={controls?.dataTables?.collectionCashes?.buttons?.add?.id}
                                                    className={controls?.dataTables?.collectionCashes?.buttons?.add?.className}
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: currentMethod, })?.result || !isEditDelete}
                                                    onClick={(e) => collectionCashAddEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: 0, subMethod: 'btn - collectionCashAdd', })}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.collectionCashes?.icons?.add?.id} className={controls?.dataTables?.collectionCashes?.icons?.add?.className} /> <span id={controls?.dataTables?.collectionCashes?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/*<button id={controls?.dataTables?.collectionCashes?.buttons?.delete?.id}
                                                    className={controls?.dataTables?.collectionCashes?.buttons?.delete?.className}
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: currentMethod, })?.result || !isEditDelete}
                                                    hidden={true}
                                                    onClick={(e) => localCollectionCashDeleteGetAsync(e)}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.collectionCashes?.icons?.delete?.id} className={controls?.dataTables?.collectionCashes?.icons?.delete?.className} /> <span id={controls?.dataTables?.collectionCashes?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                                                </button>*/}

                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtCollectionCashesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}

                </section>{/* /.content */}

            </div>

            {collectionCashShowModal ?
                <CollectionCashAddEditDetails $={$}
                    auth={auth}
                    building={building}
                    buildingBalanceCalculateSetAsync={buildingBalanceCalculateSetAsync}
                    collectionCash={collectionCash}
                    setCollectionCash={setCollectionCash}
                    coins={coins}
                    dtCollectionCashesId={dtCollectionCashesId}
                    dtRowIndex={dtCollectionCashesRowIndex}
                    showModal={collectionCashShowModal}
                    setShowModal={setCollectionCashShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}